import { logActivity, createActivityData, ACTIVITY_TYPES, SEVERITY_LEVELS } from '../services/activityLogger';

// Wrapper function to add logging to any function
export const withLogging = (originalFunction, activityType, severity = SEVERITY_LEVELS.MEDIUM) => {
    return async (user, ...args) => {
        try {
            // Call the original function
            const result = await originalFunction(...args);

            // Log the activity if successful
            if (result && (result.success !== false)) {
                const activityData = createActivityData(user, activityType, {
                    ...result,
                    timestamp: new Date().toISOString()
                }, severity);

                await logActivity(activityData);
            }

            return result;
        } catch (error) {
            console.error('Error in logged function:', error);
            throw error;
        }
    };
};

// Specific logging functions for common actions
export const logCustomerDeletion = async (user, customerId, customerName) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.CUSTOMER_DELETED, {
        customerId,
        customerName
    }, SEVERITY_LEVELS.HIGH);

    return await logActivity(activityData);
};

export const logServicemanDeletion = async (user, servicemanId, servicemanName) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.SERVICEMAN_DELETED, {
        servicemanId,
        servicemanName
    }, SEVERITY_LEVELS.HIGH);

    return await logActivity(activityData);
};

export const logServicemanUpdate = async (user, servicemanId, servicemanName, changes) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.SERVICEMAN_UPDATED, {
        servicemanId,
        servicemanName,
        changes
    }, SEVERITY_LEVELS.MEDIUM);

    return await logActivity(activityData);
};

export const logServicemanApproval = async (user, servicemanId, servicemanName, approved) => {
    const activityType = approved ? ACTIVITY_TYPES.SERVICEMAN_APPROVED : ACTIVITY_TYPES.SERVICEMAN_REJECTED;
    const activityData = createActivityData(user, activityType, {
        servicemanId,
        servicemanName,
        approved
    }, SEVERITY_LEVELS.MEDIUM);

    return await logActivity(activityData);
};

export const logUserCreation = async (user, newUserId, newUserName, newUserRole) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.USER_CREATED, {
        userId: newUserId,
        userName: newUserName,
        userRole: newUserRole
    }, SEVERITY_LEVELS.MEDIUM);

    return await logActivity(activityData);
};

export const logUserUpdate = async (user, targetUserId, targetUserName, targetUserRole, changes) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.USER_UPDATED, {
        userId: targetUserId,
        userName: targetUserName,
        userRole: targetUserRole,
        changes
    }, SEVERITY_LEVELS.MEDIUM);

    return await logActivity(activityData);
};

export const logUserDeletion = async (user, targetUserId, targetUserName, targetUserRole) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.USER_DELETED, {
        userId: targetUserId,
        userName: targetUserName,
        userRole: targetUserRole
    }, SEVERITY_LEVELS.HIGH);

    return await logActivity(activityData);
};

export const logPasswordChange = async (user, targetUserId, targetUserName) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.USER_PASSWORD_CHANGED, {
        userId: targetUserId,
        userName: targetUserName
    }, SEVERITY_LEVELS.MEDIUM);

    return await logActivity(activityData);
};

export const logLogin = async (user) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.LOGIN, {
        loginTime: new Date().toISOString()
    }, SEVERITY_LEVELS.LOW);

    return await logActivity(activityData);
};

export const logLogout = async (user) => {
    const activityData = createActivityData(user, ACTIVITY_TYPES.LOGOUT, {
        logoutTime: new Date().toISOString()
    }, SEVERITY_LEVELS.LOW);

    return await logActivity(activityData);
};
